// MST
import { types, flow, cast } from 'mobx-state-tree'

// Interfaces
import { IAboutUsWebpageApiResponse, IAboutUsWebpage, IAboutUsWebpageGetAttrs } from 'interfaces/webpage/about-us'

// Extensions
import { withEnvironment } from 'models/extensions/with-environment'
import { withHelper_baseResponseWebpage } from 'models/extensions/with-helper'

const AboutUsWebpageStore = types
  .model('AboutUsWebpage')
  .props({
    aboutUsWebpage_isLoading: types.optional(types.boolean, false),
    aboutUsWebpage_webpage: withHelper_baseResponseWebpage(),
  })
  .actions(self => ({
    aboutUsWebpage_SET_LOADING: (payload: boolean): void => {
      self.aboutUsWebpage_isLoading = payload
    },
    aboutUsWebpage_SET_ABOUT_US_WEBPAGE: (payload: IAboutUsWebpage): void => {
      self.aboutUsWebpage_webpage = cast(payload)
    },
    aboutUsWebpage_CLEAR_ABOUT_US_WEBPAGE: (): void => {
      self.aboutUsWebpage_webpage = cast({})
    },
  }))
  .extend(withEnvironment)
  .actions(self => ({
    /**
     * @description Fetch about us webpage
     *
     * @param {IAboutUsWebpageGetAttrs} payload
     *
     * @return {any} any
     */
    aboutUsWebpage_fetchAboutUsWebpage: flow(function* (payload: IAboutUsWebpageGetAttrs) {
      self.aboutUsWebpage_SET_LOADING(true)

      const response: IAboutUsWebpageApiResponse = yield self.environment.aboutUsWebpageApi.aboutUsWebpage_getAboutUs(payload)
      if (response.ok) self.aboutUsWebpage_SET_ABOUT_US_WEBPAGE(response.res.data)

      self.aboutUsWebpage_SET_LOADING(false)
    }),
  }))

export const createAboutUsWebpageStoreDefaultModel = () => types.optional(AboutUsWebpageStore, {})
